import { PhoneNumberFormat, PhoneNumberUtil } from 'google-libphonenumber';

const phoneNumberUtil: PhoneNumberUtil = PhoneNumberUtil.getInstance();

export const formatPhoneNumber = (phoneNumber: string): string => {
    let formatNumber: string = '';
    try {
        const rawNumber: libphonenumber.PhoneNumber = phoneNumberUtil.parseAndKeepRawInput(phoneNumber, 'BE');
        formatNumber = phoneNumberUtil.format(rawNumber, PhoneNumberFormat.INTERNATIONAL);
    } catch (e) {}
    return formatNumber;
};
